import { memo } from 'react';
import PlaybookOverlayWrapperAsync from './PlaybookOverlayWrapperAsync';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const OverlaysRightSidebar = ({
  objectType,
  subject,
  subjectId
}) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(PlaybookOverlayWrapperAsync, {
      objectType: objectType,
      subject: subject,
      subjectId: subjectId
    })
  });
};
OverlaysRightSidebar.displayName = 'OverlaysRightSidebar';
export default /*#__PURE__*/memo(OverlaysRightSidebar);